import styles from "./categoryButtons.module.scss"
import { Fragment } from "react"
import StyledText from "../../../typography/typography-component"
import { Divider } from "@mui/material"
import skColors from "../../../../styles/skColors"
import { RatgeberCategoryPage, RatgeberCategorySummary } from "../../_types"
import { useRouter } from "next/router"

const CategoryButtons = ({categories}: {categories: (RatgeberCategorySummary | RatgeberCategoryPage)[]}) => {
  const router = useRouter()


  return (
    <div className={styles.categoryButtonList}>
      {categories.map((item, index) => {

  const isRatgeberCategorySummary = "title" in item && "slug" in item && !("meta" in item)
        const slug = isRatgeberCategorySummary ? item?.slug : item?.meta.slug
        const goToCategory = (e: React.MouseEvent) => {
          e.stopPropagation()
          router.push(`/ratgeber/${slug}`)
        }

        return (
          <Fragment key={slug}>
            <div onClick={goToCategory} className={styles.categoryButton}>
              <StyledText variant={"pRegular"}>{item.title}</StyledText>
            </div>
            {index != categories.length - 1 && (
              <Divider
                key={`divider-${index}`}
                orientation="vertical"
                style={{ border: `1px solid ${skColors.turquoise[300]}` }}
                flexItem
              />
            )}
          </Fragment>
        )
      })}
    </div>
  )
}

export default CategoryButtons